import React, { Component } from 'react';
import {
  Input,
  TextArea,
  Form,
  Accordion,
  Loader,
  Select,
  Button,
  Message,
} from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { crudSaveChanges } from '../../actions';
import { store } from '../../store';
import additionalMessages from '../../messages';
import { uiSet } from '../mainframe/mainframe.reducer';
import PermissionsPanel from './PermissionsPanel';
import messages from '../../messages';
import DisplayClutterProperties from './DisplayClutterProperties';
import { convertObjectKeys, toSnake } from 'src/utils/change-case';
import { PREDICTION_MODEL_OPTIONS } from 'src/app.constants';
import RouteLeavingGuard from 'src/components/RouteLeavingGuard';
import { DESCRIPTION_MAX_LENGTH } from 'src/app.constants';
import StoredAccordion from 'src/components/StoredAccordion';
import { PanelHeading } from 'src/components/PanelHeading';
import { km_to_length } from 'src/utils/useful_functions';
import ProjectCustomFields from './ProjectCustomFields';

/**
 * Project panel
 */
class ProjectPanelContainer extends Component {
  state = {
    modified: false,
    initialFormValues: null,
    activePanels: [0],
    reportLoading: false,
    customFieldsValid: true,
  };

  componentDidMount() {
    // Store initial form values when the component mounts
    // which will be used to reset the form
    if (!this.state.modified) {
      const { generalProjectProps, useClutter, predictionModel, enableLidar } =
        this.props;

      this.setState({
        initialFormValues: {
          useClutter,
          predictionModel,
          generalProjectProps,
          enableLidar,
        },
      });
    }
  }

  onBlur = (e) => {
    //this.saveChange();
  };

  onKey = (e) => {
    if (e.key === 'Enter') {
      //this.saveChange();
    }
  };

  saveChange = () => {
    if (this.state.modified) {
      store.dispatch(
        crudSaveChanges({
          kind: 'project',
          options: { projectId: this.props.projectId },
          data: {
            data: convertObjectKeys(this.props.generalProjectProps, toSnake),
            use_clutter: this.props.useClutter,
            prediction_model: this.props.predictionModel,
            enable_lidar: this.props.enableLidar,
          },
        })
      );
      this.setState({ modified: false });
    }
  };

  onChange = (e, { name, value, checked }) => {
    if (!this.props.permissionWrite) {
      return;
    }
    const generalProperties = [
      'customerName',
      'companyName',
      'address',
      'phone',
      'cellPhone',
      'email',
      'description',
    ];
    if (generalProperties.includes(name)) {
      store.dispatch(
        uiSet({
          generalProjectProps: {
            ...this.props.generalProjectProps,
            ...{
              [name]: value ? value : checked,
            },
          },
        })
      );
    } else {
      store.dispatch(
        uiSet({
          [name]: value ? value : checked,
        })
      );
    }
    this.setState({ modified: true });
  };

  resetForm = () => {
    if (!this.props.permissionWrite || !this.state.modified) {
      return;
    }

    const { generalProjectProps, useClutter, predictionModel, enableLidar } =
      this.state.initialFormValues;

    store.dispatch(
      uiSet({
        generalProjectProps: convertObjectKeys(
          {
            ...this.props.generalProjectProps,
            ...generalProjectProps,
          },
          toSnake
        ),
        useClutter,
        predictionModel,
        enableLidar,
      })
    );

    this.setState({ modified: false });
  };

  render = () => {
    const props = this.props;
    const {
      projectName,
      useClutter,
      predictionModel,
      generalProjectProps,
      defaultLidarProjects,
      lidarLength,
      enableLidar,
      rangeUnits,
    } = props;
    const { activePanels } = this.state;
    // we can add check for any property(useClutter, generalProjectProps) to show loader
    if (!predictionModel) {
      return <Loader active inline />;
    }

    const {
      customerName,
      companyName,
      address,
      email,
      phone,
      cellPhone,
      description,
      customFields,
    } = generalProjectProps;
    const { formatMessage } = props.intl;

    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <PanelHeading
          title={
            <>
              <FormattedMessage id="common.project" defaultMessage="Project" />:{' '}
              {projectName}
            </>
          }
          toolbar={
            <Button
              compact
              color="blue"
              data-testid="saveProjectDetails"
              disabled={!this.state.modified || !this.state.customFieldsValid}
              onClick={this.saveChange}
              accesskey="a"
            >
              {formatMessage(additionalMessages.apply)}
            </Button>
          }
        />
        <Form style={{ flex: '1 1 auto', overflowY: 'auto', maxWidth: '40vw' }}>
          <Accordion exclusive={false} fluid className="project-details-panels">
            <StoredAccordion
              name="general properties"
              title={
                <FormattedMessage
                  id="common.generalProperties"
                  defaultMessage="General Properties"
                />
              }
            >
              <Form.Group>
                <Form.Field
                  name="customerName"
                  control={Input}
                  label={formatMessage(additionalMessages.customerName)}
                  value={customerName ? customerName : ''}
                  onBlur={this.onBlur}
                  onChange={this.onChange}
                  onKeyPress={this.onKey}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  minLength={1}
                  maxLength={60}
                />

                <Form.Field
                  name="companyName"
                  control={Input}
                  label={formatMessage(additionalMessages.companyName)}
                  value={companyName ? companyName : ''}
                  onBlur={this.onBlur}
                  onChange={this.onChange}
                  onKeyPress={this.onKey}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  minLength={1}
                  maxLength={60}
                />
              </Form.Group>
              <Form.Field
                name="address"
                control={TextArea}
                label={formatMessage(additionalMessages.address)}
                value={address ? address : ''}
                onBlur={this.onBlur}
                onChange={this.onChange}
                onKeyPress={this.onKey}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
              />
              <Form.Group>
                <Form.Field
                  name="email"
                  control={Input}
                  label={formatMessage(additionalMessages.email)}
                  value={email ? email : ''}
                  onBlur={this.onBlur}
                  onChange={this.onChange}
                  onKeyPress={this.onKey}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  minLength={1}
                  maxLength={60}
                />
                <Form.Field
                  name="phone"
                  control={Input}
                  label={formatMessage(additionalMessages.phone)}
                  value={phone ? phone : ''}
                  onBlur={this.onBlur}
                  onChange={this.onChange}
                  onKeyPress={this.onKey}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  minLength={1}
                  maxLength={60}
                />
                <Form.Field
                  name="cellPhone"
                  control={Input}
                  label={formatMessage(additionalMessages.cellPhone)}
                  value={cellPhone ? cellPhone : ''}
                  onBlur={this.onBlur}
                  onChange={this.onChange}
                  onKeyPress={this.onKey}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  minLength={1}
                  maxLength={60}
                />
              </Form.Group>

              <Form.Field
                name="description"
                control={TextArea}
                label={formatMessage(additionalMessages.description)}
                value={description ? description : ''}
                onBlur={this.onBlur}
                onChange={this.onChange}
                onKeyPress={this.onKey}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                maxLength={DESCRIPTION_MAX_LENGTH}
              />
              <ProjectCustomFields
                values={customFields || {}}
                disabled={!this.props.permissionWrite}
                onValidityChange={(valid) => {
                  if (this.state.customFieldsValid !== valid) {
                    this.setState({ customFieldsValid: valid });
                  }
                }}
                onChange={(nextCustomFields) => {
                  if (!this.props.permissionWrite) {
                    return;
                  }
                  store.dispatch(
                    uiSet({
                      generalProjectProps: {
                        ...this.props.generalProjectProps,
                        customFields: nextCustomFields,
                      },
                    })
                  );
                  this.setState({ modified: true });
                }}
              />
            </StoredAccordion>
            <StoredAccordion
              name="project properties"
              title={
                <FormattedMessage
                  id="projectDetails.projectProperties"
                  defaultMessage="Project Properties"
                />
              }
            >
              <Form.Group>
                <Form.Field
                  control={Select}
                  name="predictionModel"
                  value={predictionModel}
                  disabled={!this.props.permissionWrite}
                  onBlur={this.onBlur}
                  onChange={this.onChange}
                  label={formatMessage(additionalMessages.predictionModel)}
                  options={PREDICTION_MODEL_OPTIONS}
                  width={6}
                  placeholder={formatMessage(
                    additionalMessages.predictionModel
                  )}
                />
                <Form.Checkbox
                  name="useClutter"
                  onBlur={this.onBlur}
                  onChange={this.onChange}
                  checked={useClutter}
                  style={{ marginTop: '22px' }}
                  label={formatMessage(additionalMessages.useClutter)}
                />
                {defaultLidarProjects && (
                  <Form.Checkbox
                    name="enableLidar"
                    onChange={this.onChange}
                    checked={enableLidar}
                    style={{ marginTop: '22px' }}
                    label={formatMessage(
                      additionalMessages.enableLidarProfiles
                    )}
                  />
                )}
              </Form.Group>
              {defaultLidarProjects && (
                <Message info visible compact>
                  <div>
                    The existing profiles associated with this project are not
                    automatically refreshed when the <b>Use LiDAR Profiles</b>{' '}
                    setting is updated. When checked, any new links will use a
                    high-res path profile if the data is available and the path
                    length is less than{' '}
                    {km_to_length(lidarLength / 1000).toFixed(3)} {rangeUnits}.
                  </div>
                  <br />
                  <div>
                    Uncheck this option if you see repeated{' '}
                    <b>
                      <i>Missing high resolution profile data</i>
                    </b>{' '}
                    warnings.
                  </div>
                </Message>
              )}
            </StoredAccordion>
            {useClutter && (
              <>
                <StoredAccordion
                  name="clutter"
                  title={formatMessage(messages.clutterHeights)}
                >
                  <DisplayClutterProperties></DisplayClutterProperties>
                </StoredAccordion>
              </>
            )}
            <StoredAccordion
              name="permissions"
              title={
                <FormattedMessage
                  id="common.permissions"
                  defaultMessage="Permissions"
                />
              }
            >
              <PermissionsPanel
                projectId={this.props.projectId}
                isAdmin={this.props.permissionAdmin}
              />
            </StoredAccordion>
          </Accordion>
        </Form>
        <RouteLeavingGuard
          when={this.state.modified}
          shouldBlockNavigation={() => {
            if (this.state.modified) {
              return true;
            }
            return false;
          }}
          yes="Yes"
          no="No"
          title={`${formatMessage(additionalMessages.project)}: ${projectName}`}
          content={formatMessage(additionalMessages.warning)}
          callback={this.resetForm}
        />
      </div>
    );
  };
}

const ProjectPanel = connect((state) => {
  return {
    projectName: state.mainFrame.projectName,
    useClutter: state.mainFrame.useClutter,
    predictionModel: state.mainFrame.predictionModel,
    generalProjectProps: state.mainFrame.generalProjectProps,
    projectId: state.mainFrame.projectId,
    permissionWrite: state.mainFrame.permissionWrite,
    permissionAdmin: state.mainFrame.permissionAdmin,
    defaultLidarProjects:
      state.mainFrame.allowedFeatures?.default_lidar_projects,
    lidarLength: state.mainFrame.allowedFeatures?.default_lidar_length || 0,
    enableLidar: state.mainFrame.enableLidar,
    rangeUnits: state.mainFrame.prefs.rangeUnits,
  };
})(ProjectPanelContainer);

export default injectIntl(ProjectPanel);
